/**
 * Light or dark, by the person's choice — and light until they make one.
 *
 * Light by default rather than following the device: this is read outdoors, on
 * a dock, in Caribbean sun, and the seascape is drawn as ink on paper. Dark is
 * one tap away for anybody who wants it, and the choice sticks. Applied in
 * main.tsx before the first render, so there is no flash of the other theme.
 */
export type Theme = 'light' | 'dark'

const KEY = 'theme'
export const DEFAULT_THEME: Theme = 'light'

export function storedTheme(): Theme | null {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'light' || v === 'dark' ? v : null
  } catch {
    return null
  }
}

/** What is actually showing right now. */
export function currentTheme(): Theme {
  return storedTheme() ?? DEFAULT_THEME
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme
}

export function setTheme(theme: Theme): void {
  try { localStorage.setItem(KEY, theme) } catch { /* private mode: still applies for this visit */ }
  applyTheme(theme)
}
